import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchLandingpages } from 'src/api/welcome';
import {
    FETCH_LANDINGPAGES,
    requestLandingpages,
    requestLandingpagesFailure,
    requestLandingpagesSuccess,
} from './actions';

/* Landingpages */
function* fetchLandingpagesSaga(action: AnyAction): SagaIterator {
    yield put(requestLandingpages());

    const { error, response } = yield call(fetchLandingpages, action.identifier);

    if (error) yield put(requestLandingpagesFailure(error));
    else yield put(requestLandingpagesSuccess(response));
}

export function* generateFetchLandingpagesWatcher() {
    yield takeLatest(FETCH_LANDINGPAGES, fetchLandingpagesSaga);
}
